import Immutable from "immutable";
import React from "react";
import useFormComponentState from "../../../../common/forms/useFormComponentState";
import { SearchCriterion } from "../common/SearchCriterion";
import Autosuggest, { AutosuggestProps } from "./Autosuggest";
import { requiredRolesType } from "../../../../common/types/search/search";

export const AUTOSUGGEST_CRITERION_INITIAL_STATE = Immutable.Map();

interface AutosuggestCriterionProps extends AutosuggestProps {
	label: string;
	prefix?: string;
	quickSearch?: boolean;
	requiredRoles?: requiredRolesType;
	criterionKey: string;
}

export function AutosuggestCriterion({
	label,
	prefix,
	quickSearch = false,
	requiredRoles,
	criterionKey,
	...props
}: AutosuggestCriterionProps) {
	const { currentInput, onInputChange } = useFormComponentState(
		criterionKey,
		AUTOSUGGEST_CRITERION_INITIAL_STATE,
	);

	return (
		<SearchCriterion
			label={label}
			quickSearch={quickSearch}
			requiredRoles={requiredRoles}
		>
			<Autosuggest
				label={label}
				criterionKey={criterionKey}
				currentInput={currentInput}
				onInputChange={onInputChange}
				prefix={prefix}
				quickSearch={quickSearch}
				{...props}
			/>
		</SearchCriterion>
	);
}
